// extracted by mini-css-extract-plugin
export default {"card_course":"CourseCard_card_course__9gqBD","less_wrp":"CourseCard_less_wrp__zQNMi"};